import React from "react";
import {LoginContainer} from "./LoginLayout.styles";

export const LoginLayout = ({children}) => {
    return <LoginContainer>{children}</LoginContainer>;
};
